import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ModalCreateProfileComponent } from '../modals/modal-create-profile/modal-create-profile.component';
import { ModalWithCheckboxesList } from '../modals/modal-with-checkboxes-list/modal-with-checkboxes-list.component';
import { AccountDataDTO, UserAccountDTO, UsersAccountDTO } from '../../classes/user-account.dto';
import { HttpService } from '../../services/http.service';
import { AppointmentStepperService } from '../../services/appointment-stepper.service';
import { ModalWithTwoButtonsComponent } from '../modals/modal-with-two-buttons/modal-with-two-buttons.component';
import { Subject, takeUntil } from 'rxjs';
import { DataService } from '../../services/data.service';
import { AppointmentsTableComponent } from '../appointments-table/appointments-table.component';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { ModalOneInputComponent } from '../modals/modal-one-input/modal-one-input.component';

@Component({
    selector: 'app-profile-management',
    imports: [TranslateModule, AppointmentsTableComponent],
    templateUrl: './profile-management.component.html',
    styleUrls: ['./profile-management.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileManagementComponent implements OnInit, OnDestroy {
  users: UsersAccountDTO | null = null;
  private destroy$ = new Subject<void>();
  rows!: any;
  adultRows: any[] = [];
  columns!: any;
  adultColumns!: any;
  minorUserName: string[] = [];
  isUserManagementAble: boolean = true;
  minorUsers: any[] = [];

  constructor(
    private modal: NzModalService,
    private translateService: TranslateService,
    private http: HttpService,
    private appointmentStepperService: AppointmentStepperService,
    private dataService: DataService,
    private router: Router,
    private storage: StorageService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private toast: ToastrService
  ) {}

  ngOnInit() {
    this.getUsers();
    this.checkParams();
    this.translateService.onLangChange.subscribe(() => {
      this.getColumns();
    });
  }

  private checkParams() {
    const myParam = this.route.snapshot.queryParamMap.get('value');
    if (myParam) {
      this.create();
    }
  }

  private getUsers() {
    if (this.appointmentStepperService.getUsers()) {
      this.users = this.appointmentStepperService.getUsers();
      this.getTableData();
    } else {
      const activeUser: UserAccountDTO = JSON.parse(localStorage.getItem('userData')!);
      this.http
        .getUsers(activeUser)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: UsersAccountDTO) => {
          if (res) {
            this.users = res;
            this.appointmentStepperService.setUsers(res);
            this.getTableData();
            this.cdr.detectChanges();
          }
        });
    }
  }

  private getTableData() {
    this.getColumns();
    this.getRows();
    this.getAdultRows();
  }

  private getColumns() {
    this.translateService.get('personalArea.profileManagement').subscribe((texts) => {
      this.columns = texts.columns;
    });
  }

  private getRows() {
    const rows: any = [];
    if (this.users?.relatedProfiles) {
      const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
      this.isUserManagementAble = userData.functions ? userData.functions!.includes('MPM') : false;
      this.users?.relatedProfiles.forEach((user) => {
        rows.push({
          fullName: user.fullName,
          isMajorDelegateEnabled: !user.isMajorDelegateEnabled,
          isPrivateArea: user.isChangeProfileEnabled ? true : undefined,
          action: user.isChangeProfileEnabled ? 'Passa ad ' + user.fullName : false,
          individualId: user.individualId,
          isAdult: user.isAdult,
          connectionId: user.connectionId,
          email: user.email,
          delete: this.isUserManagementAble ? true : true,
        });
      });
    }
    this.rows = rows;
  }

  private getAdultRows() {
    const rows: any[] = [];
    this.minorUserName = [];
    this.minorUsers = this.users?.relatedProfiles.filter((res) => !res.isAdult)!;
    this.minorUsers?.forEach((res, index) => {
      if (!rows[index]) {
        rows[index] = [];
      }
      this.users?.relatedProfiles.forEach((user) => {
        if (user.isAdult) {
          rows[index].push({
            fullName: user.fullName,
            isMinorDelegateEnabled: res.isMinorDelegateEnabled,
            isShared: res.relatedMajorUsers.find((res: any) => res.fullName === user.fullName) ? false : true,
            individualId: user.individualId,
            mainFullName: res.fullName,
            mainIndividualId: res.individualId,
          });
        }
      });
    });
    this.adultRows = rows;
    this.adultColumns = this.columns.slice(0, 2);
  }

  protected share(): void {
    const textsModal = this.translateService.instant('shareProfileModal');
    const modal = this.modal.create({
      nzContent: ModalWithCheckboxesList,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          texts: {
            ...textsModal,
          } /* Todo filtrare i dati da this.users e inserirli in elements */,
          elements: ['-'],
          actionCallback: (selectedValue: string) => {
            modal.close();
            this.openSecondModalShare(selectedValue);
          },
        },
      },
    });
  }

  public openSecondModalShare(selectedValue: any): void {
    const textsModal = this.translateService.instant('confirmShareProfileModal');
    if (textsModal) {
      const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
      textsModal.content = textsModal?.content?.replace('%profile', selectedValue.fullName);
      const modal = this.modal.create({
        nzContent: ModalWithTwoButtonsComponent,
        nzClosable: true,
        nzFooter: null,
        nzData: {
          dataModal: {
            texts: {
              ...textsModal,
              first_button_pointer: 'share',
            },
            actionButton: () => this.handleCreateTutorConnection(selectedValue.individualId, userData.individualId, modal),
          },
        },
      });
    }
  }

  private handleCreateTutorConnection(firstId: string, secondId: string, modalRef: NzModalRef<ModalWithTwoButtonsComponent, any>): void {
    this.http
      .createTutorConnection(firstId, secondId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => {
        this.appointmentStepperService.clearUsers();
        this.getUsers();
        modalRef.close();
      });
  }

  protected create(): void {
    const modalTwoButtonsRef = this.modal.create({
      nzContent: ModalCreateProfileComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          actionButton: () => {
            this.appointmentStepperService.clearUsers();
            this.getUsers();
            this.dataService.setChangeNavbar(true);
            modalTwoButtonsRef.close();
          },
        },
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public switchProfile(user: any) {
    if (user) {
      this.http
        .getAccountdDataNoConnectionValidations(user?.individualId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((accountData: AccountDataDTO) => {
          this.dataService.setAccountData(accountData);
          this.dataService.setAccountDataFrom(true);
          const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
          var data = { ...accountData.customer };
          data.functions = user.isAdult ? accountData.functions : userData.functions;
          this.storage.setItem('oldUserData', userData);
          this.storage.setItem('userData', data);
          this.router.navigate(['/personal-area/your-data']);
        });
    }
  }

  public updateUsers(connectionId: any) {
    this.appointmentStepperService.clearUsers();
    this.dataService.setChangeNavbar(true);
    this.getUsers();
  }

  protected openUpdateEmail(user: any) {
    const modal = this.modal.create({
      nzContent: ModalOneInputComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        saveEmail: (res: string) => {
          this.onSave(res, user);
          modal.close();
        },
      },
    });
  }

  protected onSave(email: string, user: any): void {
    if (email) {
      this.dataService.companyId$.subscribe((companyId) => {
        if (companyId) {
          const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
          this.http.updateEmail(userData.individualId, user.individualId, email).subscribe((res) => {
            this.appointmentStepperService.clearUsers();
            this.getUsers();
            const toastText = this.translate.instant('personalArea.myData.edit_successful');
            this.toast.success(toastText);
          });
        }
      });
    }
  }

  public openModalShareMinor(selectedValue: any): void {
    const textsModal = this.translateService.instant('confirmShareMinorProfileModal');
    if (textsModal) {
      textsModal.content = textsModal?.content?.replace('%minorProfile', selectedValue.mainFullName);
      textsModal.content = textsModal?.content?.replace('%profile', selectedValue.fullName);
      const modal = this.modal.create({
        nzContent: ModalWithTwoButtonsComponent,
        nzClosable: true,
        nzFooter: null,
        nzData: {
          dataModal: {
            texts: {
              ...textsModal,
              first_button_pointer: 'share',
            },
            actionButton: () => this.handleCreateTutorConnection(selectedValue.mainIndividualId, selectedValue.individualId, modal),
          },
        },
      });
      modal.afterClose.subscribe((res) => {
        if (res === undefined) {
          this.getAdultRows();
        }
      });
    }
  }
}
